import { render, staticRenderFns } from "./wallet-balance.vue?vue&type=template&id=67144d82&"
import script from "./wallet-balance.vue?vue&type=script&lang=js&"
export * from "./wallet-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports